import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleViewVersion} from "../actions/setting";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";
import axios from "axios";

const ViewVersion = ({services: initialServices = []}) => {
  const [services, setServices] = useState(initialServices);
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const isViewVersionVisible = useSelector(state => {
    return state.setting.isViewVersionVisible;
  });

  const extractVersion = (content) => {
    if (!content) return "Unknown";
    const versionMatch = content.match(/version[:\s]+([0-9.]+)/i);
    if (versionMatch) return versionMatch[1];

    const vMatch = content.match(/V-([0-9.]+)/);
    if (vMatch) return `V-${vMatch[1]}`;
    return content;
  };

  const fetchServiceData = async (index, endpoint) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST}${endpoint}`);

      const version = extractVersion(response?.data?.content);
      updateService(index, version, "Running");
    } catch (error) {
      setServices(prev =>
        prev.map((service, i) =>
          i === index ? {...service, status: "Not Running"} : service
        )
      );
    }
  };

  const updateService = (index, version, status) => {
    setServices(prev =>
      prev.map((service, i) =>
        i === index ? {...service, version, status} : service
      )
    );
  };

  useEffect(() => {
    if (isViewVersionVisible) {
      Promise.all(
        services.map((service, index) => fetchServiceData(index, service.apiEndpoint))
      );
    }
  }, [isViewVersionVisible]);

  function hideViewVersion() {
    dispatch(toggleViewVersion(false));
  }

  const openExternalLink = (url) => {
    const fullUrl = url.startsWith("http") ? url : `https://${url}`;
    window.open(fullUrl, "_blank");
  };

  return (
    <div className={"sa-popup-bg " + (!isViewVersionVisible && 'hide')}>
      <div className="sa-popup">
        <div className="version-view-box">
          <div className="sa-modal-header sticky-sa-popup-header">
            <span className="sa-model-heading">VIEW VERSION</span>
            <div className="sa-popup-close-icon" onClick={hideViewVersion}>
              <FeatherIcon className="sa-modal-close-icon" icon="x"/>
            </div>
          </div>
          <div className="sa-popup-content">
            {services.map((service, index) => (
              <div key={index} className="col-md-12 m-b-16">
                <div className="version-card-style">
                  <div className="setting-title-description">
                    <div className="view-value">{service.name}</div>
                    <div className="version-text">{service.version}</div>
                  </div>
                  <div className="setting-title-description" style={{alignItems: 'flex-end', gap: '8px'}}>
                    <button
                      style={{background: 'none', border: 'none'}}
                      onClick={() => openExternalLink(service.popupLink)}
                      title={`Open ${service.name} documentation`}
                    >
                      <FeatherIcon
                        className="feather feather-edit table-action"
                        icon="external-link"/>
                    </button>
                    <span className={`version-status-run ${service.status === 'Not Running' ? 'not-run' : ''}`}>
                        {service.status}
                        </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVersion;
